var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('EditTable',{attrs:{"reload":_vm.reload,"title":"Fragen","headers":_vm.cols,"api_load":"questions/ListQuestions","createfields":_vm.create,"api_create":"questions/CreateQuestion","editfields":_vm.edit,"api_edit":"questions/ChangeQuestion"},on:{"update:reload":function($event){_vm.reload=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }